var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anticheat"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('matches.anticheat_title')))]),_c('button',{staticClass:"launch",on:{"click":_vm.handleLaunchAnchorClick}},[_vm._v(" "+_vm._s(_vm.$t('matches.anticheat_launch'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }